import React from "react";
import SimplePrevNextPagination from "./SimplePrevNextPagination";

/**
 * All Documents pager: no total-count API. Next is enabled when the current page is full (pageSize rows).
 */
const DocumentsPagination = ({
  pageSize,
  documents = [],
  selectedPageIndex = 0,
  navigationLoading = false,
  /** When set, overrides default (full page ⇒ more items). Used for server-backed lists. */
  hasNext: hasNextOverride,
  onPageIndexChange,
}) => {
  const safeDocuments = Array.isArray(documents) ? documents : [];
  const hasNext =
    hasNextOverride !== undefined && hasNextOverride !== null
      ? hasNextOverride
      : safeDocuments.length >= pageSize;
  const hasPrevious = selectedPageIndex > 0;

  if (safeDocuments.length === 0 && !hasPrevious) {
    return null;
  }

  return (
    <SimplePrevNextPagination
      selectedPageIndex={selectedPageIndex}
      pageSize={pageSize}
      itemCount={safeDocuments.length}
      hasNext={hasNext}
      hasPrevious={hasPrevious}
      navigationLoading={navigationLoading}
      onPageIndexChange={onPageIndexChange}
    />
  );
};

export default DocumentsPagination;
